import { AxiosError } from "axios";
import {
  PagedRuleSetList,
  RuleSet,
  RuleSetList,
  RuleSetUpdateRequest,
} from "../models/ruleset";
import { backend } from "../utils/axios";

const ROUTE = "/rulesets";

export const RuleSetService = {
  getRuleSets: async (
    query?: string,
    stateId?: number
  ): Promise<RuleSetList[]> => {
    const params = new URLSearchParams();
    if (query) params.append("query", query);
    if (stateId) params.append("state", String(stateId));

    const { data } = await backend.get<RuleSetList[]>(ROUTE, { params });
    return data;
  },
  getRuleSetsPaged: async (
    page: number,
    pageSize: number,
    query?: string,
    stateId?: number
  ): Promise<PagedRuleSetList> => {
    const params = new URLSearchParams();
    if (query) params.append("query", query);
    if (stateId) params.append("state", String(stateId));

    const { data } = await backend.get<PagedRuleSetList>(
      `${ROUTE}/${page}/${pageSize}`,
      { params }
    );

    return data;
  },
  getRuleSet: async (rulesetId: string): Promise<RuleSet | undefined> => {
    try {
      const { data } = await backend.get<RuleSet>(`${ROUTE}/${rulesetId}`);
      return data;
    } catch (e) {
      if ((e as AxiosError).response?.status === 404) return;
      else throw (e as AxiosError).response?.statusText;
    }
  },
  createRuleSet: async (request: RuleSetUpdateRequest): Promise<RuleSet> => {
    const { data } = await backend.post<RuleSet>(ROUTE, {
      ...request,
      stateId: +request.stateId,
    });

    return data;
  },
  updateRuleSet: async (
    rulesetId: string,
    request: RuleSetUpdateRequest
  ): Promise<RuleSet> => {
    const res = await backend.put<RuleSet>(`${ROUTE}/${rulesetId}`, {
      ...request,
      stateId: +request.stateId,
    });
    if (res.status !== 200) {
      const message = (res as unknown as AxiosError).response
        ?.data as unknown as string;
      throw new Error(message ?? "An error occurred while saving the ruleset.");
    }
    return res.data;
  },
  getBaseUrl: (): string => {
    return process.env.REACT_APP_SERVICE_URL!;
  },
  importData: async (file: File): Promise<void> => {
    const formData = new FormData();
    formData.append(`files`, file);

    await backend.post(`/import`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },
};
